import { InjectionToken } from '@angular/core';

export let AUTH_API_URL = new InjectionToken<string>('auth.api.url');
